TacheValidator.$inject = ['validator'];

export default function TacheValidator(validator) {
    const instance = new validator();
    return instance;
}
